import React from 'react';
import PropTypes from 'prop-types';

import {
  DedicatedEventProvider,
  isEmptyCollection,
  isEventOffline,
  useBetslipState,
  useTournamentState,
} from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

import SimpleEvent from './SimpleEvent';

const SimpleEvents = props => {
  const { mainMarketTypesByPeriod, withoutFavoriteBtn } = props;
  const { events } = useTournamentState();
  const {
    settings: { feeds },
  } = useBetslipState();

  const sortedEvents = React.useMemo(
    () => Object.values(events).sort((a, b) => a.startTime - b.startTime),
    [events],
  );

  const eventsList = React.useMemo(
    () =>
      sortedEvents.map(event => {
        const { source, sportId, sportService } = event;

        const isEventFeedOffline = isEventOffline({ feeds, source, sportId, sportService });

        return (
          <DedicatedEventProvider event={event} key={event.id}>
            <SimpleEvent
              mainMarketTypesByPeriod={mainMarketTypesByPeriod}
              suspended={isEventFeedOffline}
              withoutFavoriteBtn={withoutFavoriteBtn}
            />
          </DedicatedEventProvider>
        );
      }),
    [sortedEvents, feeds, mainMarketTypesByPeriod, withoutFavoriteBtn],
  );

  if (isEmptyCollection(sortedEvents)) {
    return (
      <EmptyStateView description="sportsbook_empty_description" title="sportsbook_no_events" />
    );
  }

  return (
    <div className="tournament-body">
      <div className="event-list">{eventsList}</div>
    </div>
  );
};

SimpleEvents.propTypes = { mainMarketTypesByPeriod: PropTypes.array.isRequired };

export default SimpleEvents;
